<!-- eslint-disable max-len -->
<template>
  <v-stepper-content step="B5">
    <v-dialog
      v-model="hasMaxEmployeesDialog"
      max-width="300"
    >
      <v-card>
        <v-card-title>Max Employees</v-card-title>
        <v-card-text>
          <div>You've reached the maximum number of employees. Please submit a separate sheet with the information requested.</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="hasMaxEmployeesDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-col
      cols="12"
      :class="$vuetify.breakpoint.name !== 'sm' ? 'd-flex justify-center mx-0 px-0' : 'd-flex justify-center'"
    >
      <v-card
        flat
        outlined
        rounded="lg"
        max-width="$vuetify.breakpoint.name === 'xs' ? '95vw' : '75vw'"
        min-height="500px"
      >
        <v-row :class="$vuetify.breakpoint.name === 'xs' ? 'mt-8 mx-1' : 'mt-8 mx-5'">
          <v-col cols="12">
            <div class="text-md-h4 text-h5" :style="textColor">General Health Benefit Information 2</div>
          </v-col>

          <v-col
            cols="12"
            class="mt-5 pb-0"
          >
            <div class="text-md-body-1 text-body-2">Has anyone been treated for a disability, serious illness, been hospitalized or had surgery in the past 5 years?</div>
          </v-col>
          <v-col cols="12">
              <div class="text-subtitle-2 blue-text text--darken-4">{{ additionalDetails }}</div>
            </v-col>
          <v-col cols="12" class="pt-0">
            <v-radio-group
              v-model="disabilityInTheLast5Years"
              row
              class="mt-0"
            >
                <v-radio
                  label="Yes"
                  :value="true"
                ></v-radio>
                <v-radio
                  label="No"
                  :value="false"
                ></v-radio>
            </v-radio-group>
          </v-col>
          <!-- Additional Details -->
          <v-col cols="12" class="mt-5" v-show="disabilityInTheLast5Years === true">
            <FormEmployee
              :employeeType="'Past5'"
              :tEmployees="past5Employees === undefined ? [] : past5Employees"
              @showDialog="hasMaxEmployeesDialog = true"
            />
          </v-col>

          <v-col
            cols="12"
            class="mt-5 pb-0"
          >
            <div class="text-md-body-1 text-body-2">Is anyone currently hospitalized, confined at home, confined in a treatment facility, and/or incapable of self-support because of physical or mental disability?</div>
          </v-col>
          <v-col cols="12">
              <div class="text-subtitle-2 blue-text text--darken-4">{{ additionalDetails }}</div>
            </v-col>
          <v-col cols="12" class="pt-0">
            <v-radio-group
              v-model="hospitalizedByDisability"
              row
              class="mt-0"
            >
                <v-radio
                  label="Yes"
                  :value="true"
                ></v-radio>
                <v-radio
                  label="No"
                  :value="false"
                ></v-radio>
            </v-radio-group>
          </v-col>
          <!-- Additional Details -->
          <v-col cols="12" class="mt-5" v-show="hospitalizedByDisability === true">
            <FormEmployee
              :employeeType="'hospitalized'"
              :tEmployees="hospitalizedEmployees === undefined ? [] : hospitalizedEmployees"
              @showDialog="hasMaxEmployeesDialog = true"
            />
          </v-col>

          <v-col
            cols="12"
            class="mt-5 pb-0"
          >
            <div class="text-md-body-1 text-body-2">Has anyone been advised that medical treatment, diagnostic testing, surgery or hospitalization is necessary?</div>
          </v-col>
          <v-col cols="12">
            <div class="text-subtitle-2 blue-text text--darken-4">{{ additionalDetails }}</div>
          </v-col>
          <v-col cols="12" class="pt-0">
            <v-radio-group
              v-model="advisedForTreatment"
              row
              class="mt-0"
            >
                <v-radio
                  label="Yes"
                  :value="true"
                ></v-radio>
                <v-radio
                  label="No"
                  :value="false"
                ></v-radio>
            </v-radio-group>
          </v-col>
          <!-- Additional Details -->
          <v-col cols="12" class="mt-5" v-show="advisedForTreatment === true">
            <FormEmployee
              :employeeType="'advised'"
              :tEmployees="advisedEmployees === undefined ? [] : advisedEmployees"
              @showDialog="hasMaxEmployeesDialog = true"
            />
          </v-col>

          <v-col
            cols="12"
            class="mt-5 pb-0"
          >
            <div class="text-md-body-1 text-body-2">Is anyone currently being treated or been advised to seek treatment for any of the following:</div>
          </v-col>
          <v-col cols="12">
            <div class="text-subtitle-2 blue-text text--darken-4">Please select from the follwing conditions:</div>
          </v-col>
          <v-col cols="12">
            <v-select
              outlined
              class="rounded-lg"
              chips
              multiple
              :items="predefinedConditions"
              v-model="chosenConditions"
            ></v-select>
          </v-col>
          <!-- Additional Details -->
          <v-col cols="12" class="mt-5" v-show="chosenConditions.length > 0">
            <FormCondEmployee
              :conditions="chosenConditions"
              :tEmployees="conditionEmployees === undefined ? [] : conditionEmployees"
              @showDialog="hasMaxEmployeesDialog = true"
            />
          </v-col>

          <BenefitsBtnContinue />
        </v-row>
      </v-card>
    </v-col>
  </v-stepper-content>
</template>

<script>
import BenefitsBtnContinue from './btnBenefitsContinue.vue';
import FormEmployee from './formEmployee.vue';
import FormCondEmployee from './formCondEmployee.vue';

export default {
  name: 'BenefitsStepFive',
  components: {
    BenefitsBtnContinue,
    FormEmployee,
    FormCondEmployee,
  },
  data: () => ({
    chosenConditions: [],
    additionalDetails: 'If yes, please provide additional details by clicking the Add Employee button below.',
    hasMaxEmployeesDialog: false,
  }),
  mounted() {
    if (this.chosenConditions.length === 0) {
      const employeeConditions = this.$store.state.benefitsPacket.employees.map((x) => x.condition);
      // eslint-disable-next-line max-len
      this.chosenConditions = [...new Set(employeeConditions.filter((x) => this.predefinedConditions.includes(x)))];
    }
  },
  computed: {
    textColor() {
      if (this.$vuetify.theme.dark) {
        return 'color: #ffffff';
      }

      return 'color: #2a4f66';
    },
    predefinedConditions() {
      return this.$store.state.benefitsPacket.predefinedConditions;
    },
    past5Employees() {
      return this.$store.state.benefitsPacket.employees.filter((el) => el.type === 'Past5');
    },
    hospitalizedEmployees() {
      return this.$store.state.benefitsPacket.employees.filter((el) => el.type === 'hospitalized');
    },
    advisedEmployees() {
      return this.$store.state.benefitsPacket.employees.filter((el) => el.type === 'advised');
    },
    conditionEmployees() {
      return this.$store.state.benefitsPacket.employees.filter((el) => el.type === 'condition');
    },
    disabilityInTheLast5Years: {
      get() {
        return this.$store.state.benefitsPacket.flags.disability5Years;
      },
      set(value) {
        this.$store.commit('updateDisabilityLast5Years', value);
      },
    },
    hospitalizedByDisability: {
      get() {
        return this.$store.state.benefitsPacket.flags.hospitalizedByDisability;
      },
      set(value) {
        this.$store.commit('updateHospitalizedByDisability', value);
      },
    },
    advisedForTreatment: {
      get() {
        return this.$store.state.benefitsPacket.flags.advisedForTreatment;
      },
      set(value) {
        this.$store.commit('updateAdvisedForTreatment', value);
      },
    },
  },
  methods: {
    incrementStep() {
      const step = this.$store.state.stepper.currentStep;
      this.$store.commit('goToStep', Number(step) + 1);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
